import React from 'react';
import { useAdminCheck } from '../../hooks/useAdminCheck';
import { useWeb3 } from '../../context/Web3Context';
import { NetworkGuard } from '../wallet/NetworkGuard';
import { Alert } from '../common/StatBox';
import { InlineLoader } from '../common/Loader';

export const AdminGuard = ({ children }) => {
  const { account } = useWeb3();
  const { checking, isPrivileged, error } = useAdminCheck();

  return (
    <NetworkGuard>
      {!account && <Alert type="info">Connect a privileged wallet (owner or admin) to access the admin panel.</Alert>}
      {account && checking && <InlineLoader text="Verifying access..." />}
      {account && !checking && !isPrivileged && (
        <div className="card" style={{ textAlign: 'center', padding: 48 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>🔒</div>
          <h3>Access Denied</h3>
          <p style={{ color: 'var(--text-secondary)', marginTop: 8 }}>
            Only owner or admin wallets can access this panel.
          </p>
          {error && <div style={{ marginTop: 12, color: 'var(--neon-red)', fontSize: 13 }}>{error}</div>}
        </div>
      )}
      {account && !checking && isPrivileged && children}
    </NetworkGuard>
  );
};
